import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import * as httpClient from "../../../util/httpClient";
import { useDispatch, useSelector } from "react-redux";
import { CommonPhoneInputFields } from "../../../util/CommonMasking";
import { PATTERNS } from "../../../util/patterns";
import { useHistory } from "react-router-dom";
import * as common from "../../../util/common";
import * as Common from "../../../store/common";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { STEP_NOTIFICATION_PREFERENCE, STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION } from "../../../components/ReCompleteRegistration/ReCompleteRegistrationUtil";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber, formatPhoneNumber } from "react-phone-number-input";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useTranslation } from "react-i18next";
import { Notification } from "../../../components/common/Notification";
import Cookies from 'universal-cookie';
import { ApplicationState } from "../../../store";

interface IProps {
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
    email?: any;
    phone?: any;
    closeTwoPrevious?: any;
    nextTwoAuth?: any;
    cardType: any;
    selectedOption: any;
    showBillingAddress: any;
}

const TwoFactorMFAForm = ({ registrationState, setRegistrationState, email, phone, closeTwoPrevious, nextTwoAuth, cardType, selectedOption, showBillingAddress, registrationLookup}: IProps) => {
    const { register, handleSubmit, errors, watch, control } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const { t: tLang } = useTranslation();
    let history = useHistory();
    const dispatch = useDispatch();
    let countryValue = i18nService.get("Country");
    if (!countryValue) countryValue = "US";
    const pageURL = window.location.href;
    const [state, setState] = useState({
        code: "",
        enterCode: true,
        submitCode: false,
        errorMessage: "",
        maximumAttemptReached: false,
        SuccessfulCode: false,
        isDisable: true,
        isLoading: false,
        deliverMethod: "",
        phoneNumber: phone,
        MfaSmsNumber: phone,
        MfaVoiceCallNumber: phone,
        PersonalCountry: registrationState.country ? registrationState.country : countryValue,
    });
    const [showVerified, setShowVerified] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const unpaidCid: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.cid
            ? state.configurationState.cid
            : ""
    );

    const unpaidChannel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.channel
            ? state.configurationState.channel
            : ""
    );

    const setCommMethod = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const setCode = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };
    const isDeviceVerificationActivated = sessionStorage.getItem('activateDeviceVerificationFlag');
    const submitCode = () => {
        const requestBody = {
            SecurityCode: state.code,
        };

        httpClient.sendRequest("POST", "web/Registration/VerifyRegistrationMFA", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                setShowVerified(true);
                nextTwoAuth();
                setState({ ...state, errorMessage: "" });
                if (state.deliverMethod === "1") {
                    setRegistrationState({ ...registrationState, twoFactorMFA: { ...state, MfaVoiceCallNumber: null } });
                }
                if (state.deliverMethod === "3") {
                    setRegistrationState({ ...registrationState, twoFactorMFA: { ...state, MfaSmsNumber: null } });
                }
                if (state.deliverMethod === "0") {
                    setRegistrationState({ ...registrationState, twoFactorMFA: data });
                }
            }
            if (data && data["maximumAttemptReached"]) {
                setState({ ...state, maximumAttemptReached: true, submitCode: false, SuccessfulCode: false, enterCode: true, errorMessage: "" });
                setRegistrationState({
                    ...registrationState,
                    twoFactorMFA: { ...state, maximumAttemptReached: true, MfaVoiceCallNumber: null, MfaSmsNumber: null },
                });
                return;
            }
            if (data && data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    setState({ ...state, errorMessage: "Your Authentication Code is incorrect." });
                }
            }
        });
        window.addToDataLayer({ event: "Submit MFA Code" });
        window.addToDataLayer({
            event: "VPV",
            pageName: pageURL + " # Personal Information",
        });
    };

    const resendCode = () => {
        setState({ ...state, isLoading: true, errorMessage: "" });
        const requestBody = {
            mfaNotificationMethod: Number(state.deliverMethod),
            emailId: email,
            personalPhoneNo: phone,
            PersonalCountry: state.PersonalCountry,
        };
        httpClient.sendRequest("POST", "web/Registration/send-mfa-secureCode", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                setState({
                    ...state,
                    submitCode: true,
                    SuccessfulCode: false,
                    enterCode: false,
                    isDisable: false,
                    isLoading: false,
                    MfaSmsNumber: phone,
                    MfaVoiceCallNumber: phone
                });
                return;
            }
            if (data && data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    history.push("/register/error");
                }
                Notification({
                    type: "error",
                    title: tLang("registration.authentication.errorNotification.title"),
                    message: tLang("registration.authentication.errorNotification.message"),
                    duration: 5,
                });
            }

            setState({ ...state, isLoading: false });
        });
        window.addToDataLayer({ event: "Resend MFA Code" });
        window.addToDataLayer({
            event: "VPV",
            pageName: pageURL,
        });
    };

    const onSubmit = (data1: any) => {
        if (state.submitCode) {
            return;
        }
        setState({ ...state, isLoading: true, errorMessage: "" });

        let number =
            state.deliverMethod == "1"
                ? getCountryInfo()
                    ? data1.MfaSmsNumber.replace(/[^0-9+]/g, "")
                    : data1.MfaSmsNumber
                : state.deliverMethod == "3"
                ? getCountryInfo()
                    ? data1.MfaVoiceCallNumber.replace(/[^0-9+]/g, "")
                    : data1.MfaVoiceCallNumber
                : getCountryInfo()
                ? phone.replace(/[^0-9]/g, "")
                : phone;
        const requestBody = {
            mfaNotificationMethod: Number(state.deliverMethod),
            emailId: email,
            personalPhoneNo: phone,
            PersonalCountry: state.PersonalCountry,
        };
        httpClient.sendRequest("POST", "web/Registration/send-mfa-secureCode", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                setState({
                    ...state,
                    submitCode: true,
                    SuccessfulCode: false,
                    enterCode: false,
                    isDisable: false,
                    isLoading: false,
                    MfaSmsNumber: phone,
                    MfaVoiceCallNumber: phone
                });
                return;
            }
            if (data && data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    history.push("/register/error");
                }
                Notification({
                    type: "error",
                    title: tLang("registration.authentication.errorNotification.title"),
                    message: tLang("registration.authentication.errorNotification.message"),
                    duration: 5,
                });
            }

            setState({ ...state, isLoading: false });
        });
        window.trackTarget("SQ-Funnel-Send-MFA-Code-Step3");
        window.addToDataLayer({ event: "Send MFA Code" });
        window.addToDataLayer({
            event: "VPV",
            pageName: pageURL,
        });
    };

    const setPrevious = () => {
        closeTwoPrevious();
        /*setReCompleteRegistrationState({
            ...reCompleteRegistrationState,
            step: STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION
        });*/
        sessionStorage.setItem("mainContent", "label-account-type");
    };
    const getCountryInfo = () => {
        let currentCountry = countryValue;
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    function getFormattedDate(date: Date) {
        var year = date.getFullYear();

        var month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : "0" + month;

        var day = date.getDate().toString();
        day = day.length > 1 ? day : "0" + day;
        return month + "/" + day + "/" + year;
    }

    const formateBirthDate = (personalInfo: any) => {
        if (!personalInfo) return "";
        if (!personalInfo.dayDropdown || !personalInfo.monthDropdown || !personalInfo.yearDropdown) return "";
        const dateofBirth = new Date(Date.parse(personalInfo.monthDropdown + "/" + personalInfo.dayDropdown + "/" + personalInfo.yearDropdown));
        if (!dateofBirth) return "";
        return getFormattedDate(dateofBirth);
    };

    const onFinalSubmit = () => {
        setState({ ...state, isLoading: true });
        let expMonth = "";
        let expYear = "";
        if (registrationState.addressInfo && registrationState.addressInfo.expirationDate) {
            const expArray = registrationState.addressInfo.expirationDate.split("/");
            expMonth = expArray[0];
            expYear = expArray[1];
        }

        const DOB = formateBirthDate(registrationState.personalInfo);
        const cookies = new Cookies();
        const subscriberInfo: any = {
            Email: registrationState.personalInfo.Email,
            FirstName: registrationState.personalInfo.FirstName,
            LastName: registrationState.personalInfo.LastName,
            Phone: registrationState.personalInfo.phoneNumber.replace(/[^0-9+]/g, ""),
            DateOfBirth: DOB ? DOB : "",
            SSN: null,
            ChekcSSN: null,
            SSN4Digits: null,
            Address1: registrationState.addressInfo.address1,
            Address2: registrationState.addressInfo.address2,
            City: registrationState.addressInfo.city,
            State: registrationState.addressInfo.state,
            Zip: registrationState.addressInfo.zipcode,
            Country: registrationState.addressInfo.country,

            SMSNumber: null,
            Password: registrationState.securityInfo.password,
            MfaSmsNumber: registrationState.twoFactorMFA.MfaSmsNumber ? registrationState.twoFactorMFA.MfaSmsNumber.replace(/[^0-9+]/g, "") : null,
            MfaVoiceCallNumber: registrationState.twoFactorMFA.MfaVoiceCallNumber
                ? registrationState.twoFactorMFA.MfaVoiceCallNumber.replace(/[^0-9+]/g, "")
                : null,
            RoutingNumber: registrationState.addressInfo.routingNumber ? registrationState.addressInfo.routingNumber : "",
            IsFunnelRegistration: true,
            Cid: cookies.get('cid') ? cookies.get('cid'):unpaidCid,
            Channel: cookies.get('channel') ? cookies.get('channel') : unpaidChannel,
            WrittenInstruction: registrationState.proofInfo.writtenInstruction,
            AutomaticRenewal: registrationState.proofInfo.automaticRenewal,
            AutomaticRenewalTermsAcceptance: registrationState.proofInfo.automaticRenewalTermsAcceptance,
        };

        const NotificationPreference = {
            TextAlerts: false,
            EmailIdentityNotification: false,
            PushNotification: false,
            EmailNotification: true,
        };
        let CreditCardDetails = null;
        let EFTDetails = null;
        if (registrationState.addressInfo) {
            CreditCardDetails = {
                CardType: {
                    Options: null,
                    Selection: cardType,
                    ReadOnly: false,
                },
                NameOnCard: registrationState.addressInfo.cardholderName?.trimStart(),
                CardNumber: registrationState.addressInfo.cardNumber,
                ExpDateMo: expMonth,
                ExpDateYr: expYear,
                SecurityCode: registrationState.addressInfo.securityCode,
            };

            if (registrationState.billingInfo.paymentMethod == "EFT") {
                EFTDetails = {
                    nameOnAccount: registrationState.billingInfo.accountName,
                    routingNumber: {
                        options: ["string"],
                        selection: registrationState.billingInfo.routingNumber,
                        readOnly: true,
                    },
                    accountNumber: registrationState.billingInfo.accountNumber,
                    bankName: {
                        options: ["string"],
                        selection: registrationState.billingInfo.bankName,
                        readOnly: true,
                    },
                    accountType: {
                        options: ["string"],
                        selection: registrationState.billingInfo.accountType,
                        readOnly: true,
                    },
                };
            }
        }
        let BillingAddress = null;
        if (showBillingAddress) {
            BillingAddress = {
                Address1: registrationState.addressInfo.address1,
                Address2: registrationState.addressInfo.address2,
                City: registrationState.addressInfo.city,
                State: {
                    Options: null,
                    Selection: registrationState.addressInfo.state,
                    ReadOnly: false,
                },
                ZipCode: registrationState.addressInfo.zipcode,
                Country: registrationState.addressInfo.country,
            };
        } else {
            BillingAddress = {
                Address1: registrationState.addressInfo.billaddress1,
                Address2: registrationState.addressInfo.billaddress2,
                City: registrationState.addressInfo.billcity,
                State: {
                    Options: null,
                    Selection: registrationState.addressInfo.billstate,
                    ReadOnly: false,
                },
                ZipCode: registrationState.addressInfo.billzipcode,
                Country: registrationState.addressInfo.billcountry,
                Phone: registrationState.personalInfo.phoneNumber.replace(/[^0-9+]/g, ""),
            };
        }

        let BillingInformation = null;

        BillingInformation = {
            CreditCardDetails: CreditCardDetails,
            EFTDetails: EFTDetails,
            BillingAddress: BillingAddress,
            PaymentMode: {
                Options: null,
                Selection: "CC",
                Name: registrationState.addressInfo.cardholderName ? registrationState.addressInfo.cardholderName : "",
                SubscriptionType: selectedOption == "Monthly" ? "monthly" : "yearly",
            },
        };

        const requestBody = {
            SubscriberInfo: subscriberInfo,
            NotificationPreference: NotificationPreference,
            SecurityQuestionAnswer: registrationState.securityInfo.item,
            BillingInformation: BillingInformation,
            idfDetails: {
                monitorPrimaryEmail: registrationState.monitorPrimaryEmail ? "True" : "False"
            },
        };
        setState({ ...state, isLoading: true });
        httpClient.sendRequest("POST", "web/Registration/Complete-Registration", requestBody).then((data: any) => {
            if (data["isSuccess"]) {
                if (data && data.loginResponse) {
                    if (isDeviceVerificationActivated === 'true') {
                        httpClient.sendRequest("PUT", "web/DeviceRisk/UpdateDeviceRiskId");
                    }
                    data.loginResponse.EmailAddress = registrationState.personalInfo.email;
                    dispatch({ type: "SUBMIT_LOGIN", userInfo: data.loginResponse });
                    setState({ ...state, isLoading: false });
                    // load user services after successful login
                    dispatch(Common.actionCreators.refreshUserPermission());
                    history.push("/dashboard");
                    window.trackTarget("SQ-Funnel-Complete-Registration-Step3");
                    window.addToDataLayer({
                        event: "VPV",
                        pageName: pageURL + "/app/dashboard",
                    });
                    window.addToDataLayer({
                        event: "purchase",
                        ep: {
                            transaction_id: data.paymentTXRefNum, // field uniquely identifies transaction
                            value:
                                selectedOption == "Monthly"
                                    ? "$" + registrationLookup.packageLookup.packagDetails[0].monthlySubscriptionPrice
                                    : "$" + registrationLookup.packageLookup.packagDetails[0].yearlySubscriptionPrice, // (number), amount collected at order completion
                            tax: 0, // (number), tax collected, if not applicable set to 0
                            offer: registrationLookup.packageLookup.packagDetails[0].packageName, // offer just purchased
                            billing_type: selectedOption == "Monthly" ? "Monthly" : "Annual", // billing terms, either “Monthly” or “Annual”
                            purchase_type: "Subscription", // “Subscription”, if non-subscription, set to “Transactional”
                            cid: cookies.get('cid') ? cookies.get('cid') : unpaidCid,
                            channel: cookies.get('channel') ? cookies.get('channel') : unpaidChannel,
                        },
                    });
                }
                if ((cookies.get('cid')) && (cookies.get('channel'))) {
                    cookies.remove('cid', { path: '/' })
                    cookies.remove('channel', { path: '/' })
                }
            } else {
                if (data && data["hasError"]) {
                    if (data && data.status) {
                        switch (data.status) {
                            case "INTERNAL_ERROR":
                                history.push("/register/error");
                                window.addToDataLayer({
                                    event: "VPV",
                                    pageName: pageURL + "/app/register/error",
                                });
                                break;
                            default:
                                history.push("/register/error");
                                window.addToDataLayer({
                                    event: "VPV",
                                    pageName: pageURL + "/app/register/error",
                                });
                                break;
                        }
                    }
                }
            }
        });

        window.addToDataLayer({ event: "Submit NotificationPreference" });
    };
    const maskPhoneNumber = (phoneNumber: string) => {
        if (phoneNumber && !phoneNumber.startsWith("(")) {
            if (!phoneNumber.includes(")")) {
                if (phoneNumber.length > 6) {
                    const maskedPhoneNumber =
                        "(" + phoneNumber.substring(0, 3) + ") " + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6, phoneNumber.length);
                    return maskedPhoneNumber;
                }
            }
        }
        return phoneNumber;
    };

    let maxL = getCountryInfo() ? 15 : 14;
    let minL = getCountryInfo() ? 7 : 14;
    let validationPhone = getCountryInfo()
        ? register({
              required: true,
              maxLength: maxL,
              minLength: minL,
              pattern: PATTERNS.PHONENUMBER.pattern,
          })
        : register({
              required: true,
              maxLength: maxL,
              minLength: minL,
              pattern: PATTERNS.PHONE.pattern,
          });

    useEffect(() => {
        const el = document.getElementsByClassName("PhoneInputCountry");
        if (el && el.length > 0) {
            try {
                const childs = el[0].children;
                if (childs[0].nodeName === "SELECT") {
                    const selectEl = childs[0] as HTMLSelectElement;
                    selectEl.disabled = true;
                }
            } catch { }
        }
    }, [state.deliverMethod]);

    return (
        <div className={state.isLoading ? "box-content loading" : "box-content"}>
            <form id="form-MFA" onSubmit={handleSubmit(onSubmit)}>
                <div className="row between-sm">
                    <div className="col-xs-12  col-no-gutter">
                        <p className="twoFactorAuth-label-content">
                            Please choose a delivery method to receive an authentication code for your account. Once you get the code, enter it into the field that
                            appears below.
                        </p>
                        <div className="margin-bottom-l"></div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-no-gutter">
                    <fieldset className="form-row inline">
                        <legend style={{ visibility: "hidden" }}></legend>
                        <div className="row" style={{ width: "100%" }}>
                            <div className={`form-row inline row}`}>
                                <div className="form-label col-xs-12 col-sm-3 col-no-gutter authleftPadding">
                                    <label htmlFor="label-account-type" className="authFontSize">
                                        Delivery Method
                                    </label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-5 col-no-gutter authleftPadding">
                                    <select
                                        className="inputbox"
                                        id="label-account-type"
                                        ref={register({ required: true })}
                                        defaultValue={state.deliverMethod}
                                        name="deliverMethod"
                                        onChange={(e) => setCommMethod(e)}
                                        autoComplete="off"
                                    >
                                        <option value="">Select </option>
                                        <option value="0">Email</option>
                                        <option value="1">Text Message</option>
                                        <option value="3">Voice Call</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    {state.deliverMethod === "0" && (
                        <fieldset className="form-row inline">
                            <legend style={{ visibility:"hidden" }}></legend>
                            <div className="row" style={{ width: "100%" }}>
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter authleftPadding">
                                        <span id="label-email-option-text" className="authFontSize authSpanStyle">
                                            Email
                                        </span>
                                    </div>
                                    <div className="form-label col-xs-12 col-sm-5 col-no-gutter authleftPadding">
                                        <span id="label-email-option" className="authFontSize authPadding authSpanStyle">
                                            {email}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {state.deliverMethod === "1" && (
                        <fieldset className="form-row inline">
                            <legend style={{ visibility: "hidden" }}></legend>
                            <div className="row" style={{ width: "100%" }}>
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter authleftPadding authSpanStyle">
                                        <span id="label-phone-number-text" className="authFontSize authSpanStyle">
                                            {" "}
                                            Phone Number
                                        </span>
                                    </div>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter authleftPadding">
                                        <span id="label-phone-number" className="authPadding authFontSize authSpanStyle">
                                            +1 {formatPhoneNumber(phone)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {state.deliverMethod === "3" && (
                        <fieldset className="form-row inline">
                            <legend style={{ visibility: "hidden" }}></legend>
                            <div className="row" style={{ width: "100%" }}>
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter authleftPadding">
                                        <span id="label-voice-call-text" className="authFontSize authSpanStyle">
                                            {" "}
                                            Phone Number
                                        </span>
                                    </div>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter authleftPadding">
                                        <span id="label-voice-call" className="authPadding authFontSize authSpanStyle">
                                            +1 {formatPhoneNumber(phone)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                </div>
                {(state.deliverMethod === "1" || state.deliverMethod === "0" || state.deliverMethod === "3") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <p className="twoFactorAuth-content">
                                To complete your registration, you will be asked to enter the authentication code sent to you by the selected delivery option above.
                                Once you get the code, enter it in the field and click submit.
                            </p>
                            <div className="margin-bottom-l"></div>
                        </div>
                    </div>
                )}

                {state.enterCode && (state.deliverMethod === "1" || state.deliverMethod === "0" || state.deliverMethod === "3") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter sendCodePadding ">
                            <button
                                type="submit"
                                className="btn-default btn-primary btn-min-width sendCodeButton"
                                style={{ padding: "0.25rem 0.75rem", borderRadius: "3px" }}
                            >
                                <span className="btn-text">Send Code</span>
                            </button>
                        </div>
                    </div>
                )}
                {state.submitCode && (
                    <div className="col-xs-12 col-sm-12 col-no-gutter">
                        <fieldset className="form-row inline">
                            <legend style={{ visibility: "hidden" }}></legend>
                            <div className="row" style={{ width: "100%" }}>
                                <div className={`form-row inline row}`}>
                                        <div className="form-label col-xs-12 col-sm-3 col-no-gutter mobPl authleftPadding">
                                            <label htmlFor="label-code" className="authFontSize">Code</label>
                                    </div>
                                    <div
                                        style={{ paddingLeft: "10px" }}
                                        className={
                                            showVerified
                                                ? "form-input mobPl col-xs-12 col-sm-2 col-no-gutter margin-right-s input-wrapper"
                                                : "form-input mobPl col-xs-12 col-sm-2 col-no-gutter"
                                        }
                                    >
                                        <input
                                            type="text"
                                            readOnly={showVerified}
                                            style={{ paddingLeft: "5px" }}
                                            className="inputbox"
                                            id="label-code"
                                            onChange={(e) => setCode(e)}
                                            placeholder="Enter code here"
                                            ref={register({ required: true })}
                                            name="code"
                                        />
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-1 col-no-gutter mobVersion mobPl">
                                        <button
                                            type="button"
                                            style={{ padding: "3px 6px", borderRadius: "3px", outline: "none" }}
                                            onClick={() => submitCode()}
                                            className="mobPl btn-default btn-primary btn-min-width"
                                            disabled={showVerified}
                                        >
                                            <span className="btn-text">Submit</span>
                                        </button>
                                    </div>
                                    {!showVerified && (
                                        <div className="form-input mobPl col-xs-12 col-sm-6 col-no-gutter mobVersion">
                                            <p className="mobPl resendAuth">
                                                <span className="default_link" onClick={() => resendCode()}>
                                                    <a href="javascript:void(0)" className="default_link">
                                                        Resend Code
                                                    </a>
                                                </span>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                    </div>
                )}

                {state.errorMessage.length > 0 && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <span className="required">{state.errorMessage}</span>
                        </div>
                    </div>
                )}
                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li className="margin-left-s">
                                <button type="button" className="btn-default btn-default btn-min-width" onClick={() => setPrevious()}>
                                    <span className="btn-text">Previous</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button
                                    type="button"
                                    style={{ padding: "0.25rem 0.75rem", borderRadius: "3px" }}
                                    onClick={() => {
                                        onFinalSubmit();
                                        window.addToDataLayer({ event: "Submit Two Factor MFA Form" });
                                        window.addToDataLayer({
                                            event: "VPV",
                                            pageName: pageURL + " # Personal Information",
                                        });
                                    }}
                                    className="btn-default btn-primary btn-min-width"
                                    disabled={!showVerified}
                                >
                                    <span className="btn-text">Proceed to Dashboard</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default TwoFactorMFAForm;
